// LearningPath query for all data needed for calendar

import { LearningPathItemType, VariantType } from '../../shared/types';

export const query = `
    query {
        currentPerson {
            id
            learningPaths(filter:"ongoing") {
                id
                pathname
                learningPathItems {
                    id
                    url
                    type
                    event {
                        id
                        shortTitle
                        eventStart
                        eventEnd
                    }
                    feedbackTask {
                        id
                        shortTitle
                        deadline
                    }
                    tasks {
                        id
                        url
                        shortTitle
                        deadline
                        unlockDate
                        taskVariants {
                            id
                            variantType
                            eventStart
                            eventEnd
                        }
                    }
                    taskChoice {
                        id
                        url
                        name
                        deadline
                        unlockDate
                    }
                }
            }
        }
    }
`;

export interface ILearningPathItem {
    id: string;
    url: string | null;
    type: LearningPathItemType;
    event: {
        id: string;
        shortTitle: string;
        eventStart: string;
        eventEnd: string;
    } | null;
    feedbackTask: {
        id: string;
        shortTitle: string;
        deadline: string | null;
    } | null;
    tasks: {
        id: string;
        url: string;
        shortTitle: string;
        deadline: string | null;
        unlockDate: string | null;
        taskVariants: {
            id: string;
            variantType: VariantType;
            eventStart: string | null;
            eventEnd: string | null;
        }[];
    }[];
    taskChoice: {
        id: string;
        url: string;
        name: string;
        deadline: string | null;
        unlockDate: string | null;
    } | null;
}

export interface IData {
    currentPerson: {
        id: string;
        learningPaths: {
            id: string;
            pathname: string;
            learningPathItems: ILearningPathItem[];
        }[];
    }
}